import React, { useLayoutEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import LogoDark from '../../../assets/imgs/logo2.png'
import LogoLight from '../../../assets/imgs/logo_light.svg'
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { handlePostRequest } from "../../../services/PostTemplate";
import { InputMask } from "primereact/inputmask";
const Corporate = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const validationSchema = Yup.object().shape({
        corporateCode: Yup.mixed().required("This field is required."),
        email: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            corporateCode: "",
            email: "",
        },

        onSubmit: async (data) => {
            setSaveBtnLoading(true);
            const payload = {
                userId: userId,
                corporateCode: data.corporateCode,
                email: data.email
            }
            console.log(payload, "payload")
            try {

                const response = await dispatch(handlePostRequest("api/user/verifyCorporate", payload, false, false));
                if (response) {
                    history.push({
                        pathname: '/otppp',
                        state: { userId:userId, corporateCode: data?.corporateCode }
                    })
                } else {

                }
                setSaveBtnLoading(false);
            }
            catch (error) {
                console.log(error)
                setSaveBtnLoading(false)
            }
            setSaveBtnLoading(false)
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };


    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center  overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className="w-18rem mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: 'whitesmoke' }}>Corporate</div>
                            </div>

                            <div className="login-div">
                                <div className="col-12">

                                    <div className="mb-3">
                                        <InputMask  mask="9999-999999" variant="filled" id='corporateCode' type="text" name="corporateCode" placeholder="Enter Corporate Code" value={formik.values.corporateCode} onChange={formik.handleChange} className="w-full mb-2 p-3 " />
                                        {/* <InputText id='corporateCode' type="text" name="corporateCode" placeholder="Enter Corporate Code" value={formik.values.corporateCode} onChange={formik.handleChange} className="w-full mb-2 p-3" /> */}
                                        {getFormErrorMessage("corporateCode")}
                                    </div>
                                    <div className="mb-3">
                                        <InputText id='email' type="email" name="email" placeholder="Enter Your Email" value={formik.values.email} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                        {getFormErrorMessage("email")}
                                    </div>
                                </div>
                                <Button label="Submit" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl font-medium" />
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </>

    );
};

export default Corporate;
